var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccounting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1752 15.8309C10.6031 15.4029 10.8436 14.8224 10.8436 14.2172V5.96086C10.8436 5.16632 10.1995 4.52222 9.40495 4.52222C8.61041 4.52222 7.96631 5.16632 7.96631 5.96086V16.604C7.96631 16.7616 8.02891 16.9128 8.14035 17.0244C8.37257 17.2567 8.74924 17.2568 8.98154 17.0245L10.1752 15.8309Z",
    fill: "#00B386"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.20166 12.4861C4.20166 12.8676 4.35318 13.2334 4.6229 13.5032C5.52903 14.4094 7.07853 13.7677 7.07853 12.4861V9.35128C7.07853 8.55685 6.43452 7.91284 5.6401 7.91284C4.84567 7.91284 4.20166 8.55685 4.20166 9.35128V12.4861Z",
    fill: "#00B386"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1748 0.00012207C12.3803 0.00012207 11.7363 0.644132 11.7363 1.43856V10.7987C11.7363 12.0802 13.2858 12.722 14.192 11.8157C14.4617 11.546 14.6132 11.1801 14.6132 10.7987V1.43856C14.6132 0.644131 13.9692 0.00012207 13.1748 0.00012207Z",
    fill: "#00B386"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1925 8.7199C19.7467 8.27416 19.0239 8.2742 18.5781 8.71999L9.97593 17.3218C9.19488 18.1028 7.92857 18.1028 7.14753 17.3218L2.42194 12.5962C1.97613 12.1504 1.25334 12.1503 0.80747 12.5961C0.36153 13.0419 0.361476 13.7648 0.807348 14.2107L7.14751 20.5512C7.92855 21.3323 9.19491 21.3323 9.97597 20.5512L20.1926 10.3346C20.6385 9.88868 20.6385 9.16574 20.1925 8.7199Z",
    fill: "#004EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounting);
export default __webpack_public_path__ + "static/media/Accounting.f12c725932297e6d65398d68c3121019.svg";
export { ForwardRef as ReactComponent };